import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ico-edit",
  "use": "ico-edit-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"ico-edit\">\n    <path d=\"M11.8242 2C11.3281 2 10.8594 2.24609 10.4688 2.63281L2.35547 10.7031L1 14.7617L5.05859 13.4102L5.14453 13.3281L13.1797 5.34375C13.5664 4.95312 13.8086 4.48438 13.8086 3.98828C13.8086 3.49219 13.5664 3.02344 13.1797 2.63281C12.7891 2.24609 12.3203 2 11.8242 2ZM9.82031 4.6875L11.1133 5.98438L4.51953 12.5391L2.58203 13.1836L3.23047 11.2422L9.82031 4.6875Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol